import { restRequest } from 'common-src/features/rest/actions';
import { HttpMethods } from 'common-src/features/rest/constants';

export const getPatientSdohRequest = (query, params) =>
  restRequest({
    uri: 'patientSdoh',
    query,
    method: HttpMethods.Get,
    ...params,
  });

export const addSdoh = (body, params) =>
  restRequest({
    uri: 'patientSdoh',
    method: HttpMethods.Post,
    body,
    ...params,
  });

export const updateSdoh = (id, body, params) =>
  restRequest({
    uri: `patientSdoh/${id}`,
    method: HttpMethods.Put,
    body,
    ...params,
  });
